/** Shared interest pill options for Get Started + Settings. */
export const INTEREST_OPTIONS = [
  "Sports",
  "Music",
  "Travel",
  "Food",
  "Fashion",
  "Technology",
  "Art",
  "Fitness",
  "Gaming",
  "Photography",
  "Nature",
  "Movies",
  "Books",
  "Cooking",
  "DIY",
  "Crafts",
  "Gardening",
  "Pets",
  "Health",
  "Wellness",
];
